/**
 * @class Example
 * @package Store/Plugin
 * @project ChalkySticks
 */
export function Example(store: any) {
	store.subscribe((mutation: any, state: any) => {
		if (mutation.type === 'notification/add') {
			store.dispatch('do/something');
		}
	});
}
